export default __webpack_public_path__ + "static/media/mano-academia.012b0256.png";